import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
interface CtaButtonProps {
  text?: string;
  href?: string;
  className?: string;
  onClick?: () => void;
}
export function CtaButton({
  text = 'QUIERO MI ACCESO AHORA',
  href = '#compra',
  className = '',
  onClick
}: CtaButtonProps) {
  return <motion.a href={href} onClick={onClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        relative inline-flex items-center justify-center gap-2 
        bg-gradient-to-r from-[#d4a843] to-[#b8860b] 
        text-black font-bold text-lg md:text-xl py-4 px-8 
        rounded-full shadow-[0_0_20px_rgba(212,168,67,0.4)]
        hover:shadow-[0_0_30px_rgba(212,168,67,0.6)]
        transition-shadow duration-300 uppercase tracking-wide
        ${className}
      `} data-id="element-31">
      {text}
      <ChevronRightIcon className="w-6 h-6" data-id="element-32" />
    </motion.a>;
}